export default {
  data() {
		return {
			uniqueUsernameErrorMessage: 'username taken'
		}
	},
	computed: {
		async isValid() {
			this.$validator.fields.items.forEach(item => item.reset())
			return await this.$validator.validateAll().then(isValid => isValid)
		},
	},
  methods: {
		getInputCssClasses(fieldName, extraClasses = []) {
			const field = this.fields[fieldName]
			const validated = field && field.validated
			return [
				{ 'is-success': validated && field.valid },
				{ 'is-danger': (validated && field.invalid) || this.errors.has(fieldName) },
				...extraClasses
			]
		},
  },
};



// WEBPACK FOOTER //
// ./_common/mixins/vee-validation.mixin.js